import React from "react";
import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import Reveal from "../Reveal";

const plans = [
  { name: "Basic Care Plan", price: "199", featured: false },
  { name: "Wellness Plus Plan", price: "299", featured: false },
  { name: "Premium Care Plan", price: "499", featured: true },
  { name: "Elite Wellness Plan", price: "999", featured: false },
];

const features = ["Health Check", "Core Vaccines", "Nail Trimming", "Ear Cleaning", "Dental Check", "Nutrition Guide"];

const Pricing = () => {
  return (
    <section className="mx-auto max-w-[1290px] px-5 py-20 md:py-28">
      <Reveal animation="rubberBand" className="mx-auto max-w-2xl text-center">
        <span className="inline-flex items-center gap-2 font-display text-[15px] font-semibold text-pawelle-primary">
          Choose Package
        </span>
        <h2 className="mt-3 font-display text-[30px] font-bold leading-tight text-pawelle-ink md:text-[38px]">
          Discover Affordable Pet Wellness Options
        </h2>
      </Reveal>

      <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {plans.map((p, i) => (
          <Reveal
            key={p.name}
            animation="fadeInUp"
            delay={i * 90}
            className={`flex flex-col rounded-[28px] p-8 transition-all duration-300 hover:-translate-y-2 ${
              p.featured
                ? "bg-pawelle-primary text-white shadow-[0_24px_60px_rgba(114,82,155,0.3)]"
                : "bg-pawelle-bg text-pawelle-ink hover:shadow-[0_24px_60px_rgba(67,48,109,0.1)]"
            }`}
          >
            <img src="/pawelle/img_1.png" alt="" className="h-14 w-14 object-contain" />
            <h3 className={`mt-5 font-display text-[22px] font-semibold ${p.featured ? "text-white" : "text-pawelle-ink"}`}>{p.name}</h3>
            <p className={`mt-2 font-body text-[14px] ${p.featured ? "text-white/85" : "text-pawelle-body"}`}>
              Nisi lacinia nullam consectetuer non arcu platea sem
            </p>
            <div className="mt-5 flex items-end gap-1">
              <span className={`font-display text-[22px] font-semibold ${p.featured ? "text-white" : "text-pawelle-ink"}`}>£</span>
              <span className={`font-display text-[46px] font-bold leading-none ${p.featured ? "text-white" : "text-pawelle-ink"}`}>{p.price}</span>
              <span className={`mb-1.5 font-body text-[15px] ${p.featured ? "text-white/85" : "text-pawelle-body"}`}>/session</span>
            </div>
            <div className={`my-6 h-px w-full ${p.featured ? "bg-white/20" : "bg-pawelle-ink/10"}`} />
            <p className={`font-display text-[15px] font-semibold ${p.featured ? "text-white" : "text-pawelle-ink"}`}>Features:</p>
            <ul className="mt-4 flex-1 space-y-3">
              {features.map((f) => (
                <li key={f} className={`flex items-center gap-3 font-body text-[15px] ${p.featured ? "text-white/90" : "text-pawelle-body"}`}>
                  <span className={`flex h-5 w-5 items-center justify-center rounded-full ${p.featured ? "bg-white/20 text-white" : "bg-pawelle-primary/12 text-pawelle-primary"}`}>
                    <Check className="h-3 w-3" />
                  </span>
                  {f}
                </li>
              ))}
            </ul>
            <Link
              to="/gb/en/appointment.html"
              className={`mt-7 inline-flex items-center justify-center gap-2 rounded-full px-6 py-3.5 font-display text-[15px] font-medium transition-all duration-300 ${
                p.featured
                  ? "bg-white text-pawelle-primary hover:bg-pawelle-ink hover:text-white"
                  : "bg-pawelle-primary text-white hover:bg-pawelle-primary-dark"
              }`}
            >
              Choose Package <ArrowRight className="h-4 w-4" />
            </Link>
          </Reveal>
        ))}
      </div>

      {/* CTA strip */}
      <Reveal animation="zoomIn" className="mt-14 flex flex-col items-center justify-between gap-6 rounded-[28px] bg-pawelle-bg px-8 py-10 text-center md:flex-row md:text-left">
        <h4 className="max-w-3xl font-display text-[22px] font-semibold leading-snug text-pawelle-ink md:text-[26px]">
          Serving 18,000 Loyal Clients with Compassionate Veterinary Care
        </h4>
        <Link
          to="/gb/en/appointment.html"
          className="inline-flex flex-shrink-0 items-center gap-2 rounded-full bg-pawelle-primary px-8 py-4 font-display text-[16px] font-medium text-white transition-all duration-300 hover:bg-pawelle-primary-dark hover:-translate-y-0.5"
        >
          Get an Appointment <ArrowRight className="h-5 w-5" />
        </Link>
      </Reveal>
    </section>
  );
};

export default Pricing;
